import { apiFetch } from '../utils/api';
import { ProductVariant } from './productVariants';

export interface RelatedVariant {
  id: string;
  productVariant: ProductVariant;
  createdAt: string;
  updatedAt: string;
}

export const fetchBrandRelatedVariants = (
  brandId: string,
): Promise<RelatedVariant[]> =>
  apiFetch<RelatedVariant[]>(`/vehicle/brands/${brandId}/related-products`);

export const addBrandRelatedVariant = (
  brandId: string,
  variantId: string,
): Promise<RelatedVariant> =>
  apiFetch<RelatedVariant>(`/vehicle/brands/${brandId}/related-products`, {
    method: 'POST',
    body: JSON.stringify({ variantId }),
  });

export const removeBrandRelatedVariant = (
  brandId: string,
  relationId: string,
): Promise<void> =>
  apiFetch<void>(`/vehicle/brands/${brandId}/related-products/${relationId}`, {
    method: 'DELETE',
  });

export const fetchModelRelatedVariants = (
  modelId: string,
): Promise<RelatedVariant[]> =>
  apiFetch<RelatedVariant[]>(`/vehicle/models/${modelId}/related-products`);

export const addModelRelatedVariant = (
  modelId: string,
  variantId: string,
): Promise<RelatedVariant> =>
  apiFetch<RelatedVariant>(`/vehicle/models/${modelId}/related-products`, {
    method: 'POST',
    body: JSON.stringify({ variantId }),
  });

export const removeModelRelatedVariant = (
  modelId: string,
  relationId: string,
): Promise<void> =>
  apiFetch<void>(`/vehicle/models/${modelId}/related-products/${relationId}`, {
    method: 'DELETE',
  });
